import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import ui from './ui';
import user from './user';
import searchstats from './searchstats';
import leadsstats from './leadsstats';
import impressionstats from './impressionstats';
import companystats from './companystats';
import companyreport from './companyreport';

export default history => combineReducers({
    router: connectRouter(history),
    ui,
    user,
    searchstats,
    leadsstats,
    impressionstats,
    companystats,
    companyreport,
});
